module.exports = __webpack_public_path__ + "static/media/Dangote.fd0f2df1.png";